const getDirection = (ratio) => {
  if (ratio > 1) return 1;
  if (ratio < 1) return 2;
  return 0;
};
const getTrendClassName = (direction, desiredTrend) => {
  if (desiredTrend === "negative") {
    if (direction === 1) return "trend-negative";
    if (direction === 2) return "trend-positive";
  } else if (desiredTrend === "positive") {
    if (direction === 1) return "trend-positive";
    if (direction === 2) return "trend-negative";
  }
  return "trend-neutral";
};
const normalizeValue = (val) => val === "" || val === null || val === void 0 ? 0 : val;
const getRatio = (value, comparison) => {
  const actualValue = normalizeValue(value);
  const actualComparison = normalizeValue(comparison);
  if (actualComparison === 0 && actualValue === 0) {
    return 1;
  }
  let ratio = actualValue / actualComparison;
  if (isNaN(ratio)) {
    ratio = 0;
  }
  if (!isFinite(ratio)) {
    ratio = 1;
  }
  return ratio;
};
const getPercentageSymbol = (direction) => {
  if (direction === 1) return "+";
  if (direction === 2) return "-";
  return "";
};
export {
  getDirection,
  getPercentageSymbol,
  getRatio,
  getTrendClassName
};
